import { useActivityTracker } from "../../hooks/useActivityTracker";

const RouteTracker: React.FC = () => {
  useActivityTracker(true); // auto page view tracking
  return null;
};

export default RouteTracker;